import { inject, Injectable } from "@angular/core";
import { map } from "rxjs";
import { ConstructAPI } from "src/app/API/constructAPI";
import { RestApiService } from "src/app/API/restapi";
import { SheetDetails } from "src/model/assetSheetRequestDetails.model";

export interface AssetLogOptions {
  companyId?: number;
  requestedBy?: string;
  requestedBefore?: Date;
  requestedAfter?: Date;
}

@Injectable({
  providedIn: "root",
})
export class AssetSheetRequestService {
  private api = inject(RestApiService);
  private constructApi = inject(ConstructAPI);

  postAsstSheetRequest(details: any) {
    return new Promise<SheetDetails>((resolve, reject) => {
      this.api
        .post<SheetDetails>(this.constructApi.getPostSheetRequest(), {
          Data: details,
        })
        .subscribe({
          next: (data) => resolve(data),
          error: (error) => {
            this.api.handleError(error);
            reject(error);
          },
        });
    });
  }

  getAllAssetSheetRequests(o?: AssetLogOptions): Promise<SheetDetails[]> {
    return new Promise<SheetDetails[]>((resolve, reject) => {
      this.api
        .get<SheetDetails[]>(
          this.constructApi.getAllSheetRequests(
            o?.companyId,
            o?.requestedBefore.toISOString(),
            o?.requestedAfter.toISOString(),
            o?.requestedBy,
          ),
        )
        .pipe(map((data) => this.adaptValuesIntoSheetRequest(data)))
        .subscribe({
          next: (response) => resolve(response),
          error: (err) => {
            this.api.handleError(err);
            console.error("Failed to get all asset sheet request: ", err);
            reject(err);
          },
        });
    });
  }

  adaptValuesIntoSheetRequest(data: any): SheetDetails[] {
    const srList: SheetDetails[] = new Array();
    data.forEach((item: any) => {
      item.data.forEach((d: any) => {
        var sr = new SheetDetails();
        Object.keys(sr).forEach((key, j) => {
          (sr as any)[key] = d[j];
        });

        srList.push(sr);
      });
    });

    return srList;
  }
}
